import { render, staticRenderFns } from "./SafeDialog.vue?vue&type=template&id=3933fc20&scoped=true"
import script from "./SafeDialog.vue?vue&type=script&lang=js"
export * from "./SafeDialog.vue?vue&type=script&lang=js"
import style0 from "./SafeDialog.vue?vue&type=style&index=0&id=3933fc20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3933fc20",
  null
  
)

export default component.exports